import '@mantine/core/styles.css';
import React from 'react';
import { MantineProvider } from '@mantine/core';
import { theme } from './src/theme';
import { Notifications } from '@mantine/notifications';
import '@mantine/notifications/styles.css';
import './src/styles/effects.css';
import { YDAOPrivyProvider } from './src/contexts/PrivyContext';
import SolanaCursorAura from './src/components/SolanaCursorAura';
import Footer from './src/components/Footer';

export const wrapRootElement = ({ element }) => {
  return (
    <MantineProvider theme={theme} defaultColorScheme="dark">
      <Notifications />
      <SolanaCursorAura />
      <YDAOPrivyProvider>{element}</YDAOPrivyProvider>
    </MantineProvider>
  );
};

export const wrapPageElement = ({ element }) => (
  <>
    {element}
    <Footer />
  </>
);
